var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91489 8.84302L0.287233 5.04941C0.18085 4.96221 0.106383 4.875 0.06383 4.78779C0.0212768 4.70058 0 4.60465 0 4.5C0 4.39535 0.0212768 4.29942 0.06383 4.21221C0.106383 4.125 0.18085 4.03779 0.287233 3.95058L4.91489 0.156977C4.97872 0.104651 5.04808 0.0655815 5.12298 0.0397675C5.19787 0.0139536 5.27745 0.000697674 5.3617 0C5.53192 0 5.68085 0.0481395 5.80851 0.144419C5.93617 0.240698 6 0.366976 6 0.523255V8.47674C6 8.63371 5.93617 8.76034 5.80851 8.85662C5.68085 8.9529 5.53192 9.00069 5.3617 8.99999C5.31915 8.99999 5.17021 8.94767 4.91489 8.84302Z",
    fill: "#243267"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftV2);
export default __webpack_public_path__ + "static/media/arrow_left_v2.fc17d518253a41df135fb50f9b2f6f47.svg";
export { ForwardRef as ReactComponent };